import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">热度榜单</h2>
          <p className="text-sm md:text-base text-foreground-400">实时热门内容排行，看看大家都在关注什么</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden">
            {rankingData.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  idx < rankingData.length - 1 ? 'border-b border-background-200/60' : ''
                } hover:bg-background-100/50 transition-colors cursor-pointer`}
              >
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                  {item.rank === 1 ? (
                    <span className="text-2xl">🥇</span>
                  ) : item.rank === 2 ? (
                    <span className="text-2xl">🥈</span>
                  ) : item.rank === 3 ? (
                    <span className="text-2xl">🥉</span>
                  ) : (
                    <span className="text-lg font-black text-foreground-300">{item.rank}</span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-bold text-foreground-950 truncate">
                    {item.title}
                  </h3>
                </div>
                <div className="flex-shrink-0 flex items-center gap-2">
                  <span className="text-sm font-bold text-primary-500 whitespace-nowrap">{item.heat}</span>
                  {item.change === 'up' && (
                    <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                  )}
                  {item.change === 'down' && (
                    <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>
                  )}
                  {item.change === 'new' && (
                    <span className="px-1.5 py-0.5 text-xs font-bold bg-accent-100 text-accent-700 rounded">NEW</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}